import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { LayoutComponent } from './layout/layout.component';
import { AuthGuardService } from './authentication/auth-guard.service';
import { AuthCallbackComponent } from './authentication/auth-callback/auth-callback.component';

export const routes: Routes = [
  {
    path: '', component: LayoutComponent, canActivate: [AuthGuardService],
    children: [

      { path: '', redirectTo: '/home', pathMatch: 'full' },
      { path: 'home', loadChildren: './layout/home/home.module#HomeModule' }, ///*,canLoad: [AuthGuardService]*/ 
      { path: 'admin', loadChildren: './layout/admin/admin.module#AdminModule' },
      { path: 'vendor', loadChildren: './layout/vendor/vendor.module#VendorModule' },
      { path: 'company', loadChildren: './layout/company/company.module#CompanyModule' },
      { path: 'customer', loadChildren: './layout/customer/customer.module#CustomerModule' },
      { path: 'livemap', loadChildren: './layout/live-map/live-map.module#LiveMapModule' },
      { path: 'optimization', loadChildren: './layout/schedule-optimization/schedule-optimization.module#ScheduleOptimizationModule' },
      { path: 'technician', loadChildren: './layout/technician/technician.module#TechnicianModule' },
      { path: 'dispatch', loadChildren: './layout/dispatch/dispatch.module#DispatchModule' },
      { path: 'workorder', loadChildren: './layout/work-order/work-order.module#WorkOrderModule' },
      { path: 'quote', loadChildren: './layout/qo-work-order/qo-work-order.module#QOWorkOrderModule' },
      { path: 'reports', loadChildren: './layout/reports/reports.module#ReportsModule' },
      { path: 'approvalqueues', loadChildren: './layout/queues/approval-queue/queues.module#QueuesModule' },
      { path: 'invoicequeues', loadChildren: './layout/queues/invoice-queue/invoicequeue.module#InvoiceQueueModule' },
      { path: 'pm', loadChildren: './layout/pm/pm.module#PMModule' },
      { path: 'pm', loadChildren: './layout/pm-equipment/pm-equipment.module#PMEquipmentModule' },
      { path: 'inventory', loadChildren: './layout/inventory/inventory.module#InventoryModule' },
      { path: 'dashboards', loadChildren: './layout/dashboards/dashboards.module#DashboardsModule' },
      { path: 'integration', loadChildren: './layout/integration/integration.module#IntegrationModule' },
      { path: 'releasenotes', loadChildren: './layout/release-notes/release-notes.module#ReleaseNotesModule' },
      { path: 'dataimport', loadChildren: './layout/import/import.module#ImportModule' },
      { path: 'customview', loadChildren: './layout/custom-view/custom-view.module#CustomViewModule' },
      { path: 'workflow', loadChildren: './layout/work-flow/work-flow.module#WorkFlowModule' },
      { path: 'dynamicforms', loadChildren: './layout/dynamic-forms/dynamic-forms.module#DynamicFormsModule' },
      { path: 'partrequestqueue', loadChildren: './layout/part-request-queue/part-request-queue.module#PartRequestQueueModule' },
      { path: 'project', loadChildren: './layout/project/project.module#ProjectModule' },
      { path: 'quickworkorder', loadChildren: './layout/quick-work-order/quick-work-order.module#QuickWorkOrderModule' }
    ]
  },
  { path: 'auth-callback', component: AuthCallbackComponent },
  { path: 'account', loadChildren: './layout/account/account.module#AccountModule' },
  { path: 'jobtracking', loadChildren: './job-tracking/job-tracking.module#JobTrackingModule' },
  { path: '**', redirectTo: '/home' }
];
export const routing: ModuleWithProviders = RouterModule.forRoot(routes); /*, { useHash: false }*/